export type CSVStats = {
  enroll: number;
  verify: number;
  move_out: number;
  no_email: number;
  no_phone: number;
  resubscribe: number;
  unenroll: number;
  wrong_dob: number;
  wrong_ssn: number;
  data_update: number;
  valid_count: number;
  duplicate_ssn: number;
  invalid_count: number;
  invalid_email: number;
  invalid_phone: number;
  wrong_move_in: number;
  address_change: number;
  wrong_move_out: number;
  duplicate_email: number;
  duplicate_phone: number;
  wrong_lease_end: number;
  wrong_lease_start: number;
  wrong_rent_amount: number;
};

export type CsvUploadStatusResponse =
  | {
      id: number;
      status: CsvUploadStatus;
      stats: CSVStats;
      options: {
        enroll: boolean;
        opt_in: boolean;
        update: boolean;
        verify: boolean;
        moveout: boolean;
        opt_out: boolean;
        unenroll: boolean;
      };
      csv_filename?: string;
      result_csv_url?: string;
      updated_at: string;
    }
  | undefined;

export enum CsvUploadStatus {
  Executing = "executing",
  Executed = "executed", // Shown only once.
  Parsed = "parsed",
  Parsing = "parsing", // when csv is being validated
  Init = "init", // Likely inaccessible for the front-end.

  // These should be used like idle
  Failed = "failed",
  Canceled = "canceled"
}
